import React, { useState, useEffect, useRef } from "react";
import { Box, Grid } from "@mui/material";

import { peticionGet } from "Componentes/ComponenteAxios";
import MigaPan from "Componentes/MigaPan";
import BotonNavegar from "Componentes/Controles/BotonNavegar";
import TarjetaContador from "Componentes/Controles/TarjetaContador";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

const Dashboard = () => {
  const migaPanRef = useRef();
  const [registros, setRegistros] = useState([]);
  const [viajesHoy, setViajesHoy] = useState([]);

  useEffect(() => {
    peticionGet("/dashBoard").then(({ peticion, error }) => {
      if (error) {
        migaPanRef.current?.mostrarSnack({
          mensaje:
            peticion?.mensajeSnack || "No se han podido recuperar los datos",
          tipo: peticion?.tipoSnack || "error",
        });
      } else {
        setRegistros(peticion || {});
      }
    });
  }, []);

  useEffect(() => {
    peticionGet("/viajes/hoy").then(({ peticion, error }) => {
      if (error) {
        migaPanRef.current?.mostrarSnack({
          mensaje: "No se han podido recuperar los viajes de hoy",
          tipo: "error",
        });
      } else {
        setViajesHoy(peticion?.datos || []);
      }
    });
  }, []);
  const navegarListado = () => {
    window.location.href = "/viajes"; // o useNavigate si estás con React Router
  };

  return (
    <Box className="box-contenido-alineado-izquierda">
      <MigaPan ref={migaPanRef} tituloSeccion="Dashboard" />

      <Box mt={3}>
        {/* ===================== GRID PRINCIPAL ===================== */}
        <Grid container spacing={3}>
          {/* ──────────────── FILA 1: TARJETAS ──────────────── */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <TarjetaContador
                  titulo="Viajes de hoy"
                  valor={viajesHoy.length}
                  descripcion="Total de viajes registrados hoy"
                  icono={<DirectionsBusIcon />}
                  ruta="/viajes?fecha=hoy"
                  // loading={loadingViajes}
                />
              </Grid>

              {/* Aquí puedes añadir más tarjetas si las necesitas */}
              {/* <Grid item xs={12} sm={6} md={3}>...</Grid> */}
            </Grid>
          </Grid>

          {/* BOTÓN NUEVO VIAJE */}
          <Grid item xs={12} md={4} lg={3}>
            <BotonNavegar
              texto="Nuevo Viaje"
              descripcion="Crear un nuevo viaje"
              icono={<AddCircleOutlineIcon fontSize="inherit" />}
              ruta="/Viajes/Nuevo"
              sx={{ height: "100%" }}
            />
          </Grid>

          {/* TARJETA EJEMPLO VISUAL */}
          <Grid item xs={12} md={4} lg={3}>
            <BotonNavegar
              texto="Socios"
              descripcion="Gestionar socios"
              icono={<AddCircleOutlineIcon fontSize="inherit" />}
              ruta="/Socios"
              sx={{ height: "100%" }}
            />
          </Grid>
          {/* MÁS TARJETAS QUE PUEDAS AÑADIR */}
          <Grid item xs={12} md={4} lg={3}>
            <BotonNavegar
              texto="Clientes"
              descripcion="gestión de clientes"
              icono={<AddCircleOutlineIcon fontSize="inherit" />}
              ruta="/Clientes"
              sx={{ height: "100%" }}
            />
          </Grid>
          {/* TARJETA EJEMPLO */}
          <Grid item xs={12} md={4} lg={3}>
            <BotonNavegar
              texto="Vehículos"
              descripcion="gestión de flota"
              icono={<AddCircleOutlineIcon fontSize="inherit" />}
              ruta="/Vehiculos"
              sx={{ height: "100%" }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
